<template>
  <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel">
    <a-form :model="formState" ref="formRef" :rules="rules">
      <a-form-item label="上级部门" name="pid">
        <case-depart-ment :echoVal="formState.pid" :clear="modalConfig.visible"
          @selectSuperiorDepartment="selectSuperiorDepartment"></case-depart-ment>
      </a-form-item>
      <a-form-item label="部门名称" name="structureName">
        <a-input v-model:value="formState.structureName" placeholder="请输入部门名称"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { saveStructure } from "@/request/view/personal";
import caseDepartMent from "@/views/personnelManagement/component/department/caseDepartMent.vue";
import { Toast, debounce } from "@/utils";

export default defineComponent({
  components: { caseDepartMent },
  setup(props, context) {
    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const formState = reactive({
      custom: null,
      id: null,
      pid: null,
      structureName: null,
    });

    const validatePid = (rule, value) => {
      console.log(formState, value, rule);
      if (!value) {
        return Promise.reject("请选择上级部门");
      }
      return Promise.resolve();
    };

    const rules = {
      structureName: [
        {
          required: true,
          message: "请输入部门名称",
          trigger: "blur",
          type: "any",
        },
      ],
      pid: [
        {
          required: true,
          message: "请选择上级部门",
          validator: validatePid,
          trigger: "blur",
          type: "any",
        },
      ],
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });

      formRef.value.clearValidate();

      modalConfig.type = null;
      modalConfig.title = null;
      modalConfig.visible = false;
    };

    const showModal = (options) => {
      const { type, data, title } = options;
      modalConfig.type = type;
      modalConfig.title = title;
      modalConfig.visible = true;

      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
    };

    const selectSuperiorDepartment = (pid) => {
      formState.pid = pid;
    };

    const formRef = ref();

    const handleOk = debounce(() => {
      formRef.value
        .validate()
        .then(() => {
          saveStructure(formState).then((res) => {
            let type = res.code === 200 ? "success" : "warning";

            Toast(type, res.message, 3);
            context.emit("updateTable");
            resetForm();
          });
        })
        .catch((err) => { });
    });

    const handleCancel = () => {
      resetForm();
    };

    return {
      modalConfig,
      showModal,
      handleOk,
      selectSuperiorDepartment,
      handleCancel,
      formState,
      formRef,
      rules,
    };
  },
});
</script>

<style lang="less" scoped></style>